import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import html2canvas from 'html2canvas';

const API = process.env.REACT_APP_API_URL || '';

function Butterfly({ size = 120 }) {
  return (
    <svg width={size} height={size * 0.8} viewBox="0 0 200 160" xmlns="http://www.w3.org/2000/svg">
      <ellipse cx="60" cy="60" rx="55" ry="45" fill="#C084FC" opacity="0.9" transform="rotate(-20,60,60)" />
      <ellipse cx="140" cy="60" rx="55" ry="45" fill="#A855F7" opacity="0.9" transform="rotate(20,140,60)" />
      <ellipse cx="55" cy="100" rx="38" ry="28" fill="#9333EA" opacity="0.85" transform="rotate(20,55,100)" />
      <ellipse cx="145" cy="100" rx="38" ry="28" fill="#7C3AED" opacity="0.85" transform="rotate(-20,145,100)" />
      <path d="M100,20 Q103,80 100,140 Q97,80 100,20" fill="#4C1D95" strokeWidth="0" />
      <line x1="100" y1="20" x2="85" y2="8" stroke="#6D28D9" strokeWidth="2" strokeLinecap="round" />
      <line x1="100" y1="20" x2="115" y2="8" stroke="#6D28D9" strokeWidth="2" strokeLinecap="round" />
      <circle cx="85" cy="7" r="3" fill="#9333EA" />
      <circle cx="115" cy="7" r="3" fill="#9333EA" />
    </svg>
  );
}

// Form-mode poster (built-in designer template)
function FormPoster({ doctor, template, posterRef }) {
  const bg1 = template?.backgroundColor || '#5B21B6';
  const bg2 = template?.gradientColor || '#7C3AED';
  const textColor = template?.accentColor || '#FFFFFF';
  const headerText = template?.headerText || 'Dear Doctor,';
  const bodyText = template?.bodyText || 'Treating epilepsy is more than a medical practice - it is an art of restoring quality of life.';
  const highlightText = template?.highlightText || 'International Epilepsy Day / Purple Day 2026';
  const footerText = template?.footerText || 'Thank you for your unwavering commitment to excellence.';
  const companyName = template?.companyName || 'Hilton Pharma';
  const productName = template?.productName || 'LERACE (Levetiracetam)';

  return (
    <div ref={posterRef} style={{ width: '100%', maxWidth: 440, background: `linear-gradient(160deg, ${bg1} 0%, ${bg2} 60%, ${bg1}CC 100%)`, borderRadius: 24, overflow: 'hidden', boxShadow: '0 32px 80px rgba(76,29,149,0.4)', position: 'relative', userSelect: 'none' }}>
      <div style={{ position: 'absolute', width: 200, height: 200, borderRadius: '50%', background: 'rgba(255,255,255,0.04)', top: -60, right: -60, pointerEvents: 'none' }} />
      <div style={{ padding: '36px 32px 0', textAlign: 'center', color: textColor }}>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 20 }}>
          <div style={{ width: 110, height: 110, borderRadius: '50%', border: '4px solid rgba(255,255,255,0.6)', overflow: 'hidden', background: 'rgba(255,255,255,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 8px 32px rgba(0,0,0,0.3)' }}>
            {doctor.picture ? <img src={`${API}${doctor.picture}`} alt={doctor.name} crossOrigin="anonymous" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : <span style={{ fontSize: '3rem' }}>👨‍⚕️</span>}
          </div>
        </div>
        <div style={{ fontSize: '1.15rem', fontWeight: 800, marginBottom: 4 }}>{doctor.name}</div>
        {doctor.specialty && <div style={{ fontSize: '0.82rem', opacity: 0.8, marginBottom: 20 }}>{doctor.specialty}</div>}
        <div style={{ width: 40, height: 2, background: 'rgba(255,255,255,0.4)', margin: '0 auto 20px', borderRadius: 2 }} />
        <div style={{ fontSize: '0.88rem', lineHeight: 1.75, color: textColor }}>
          <p style={{ fontWeight: 700, fontSize: '1rem', marginBottom: 12 }}>{headerText}</p>
          <p style={{ opacity: 0.92, marginBottom: 14 }}>{bodyText}</p>
          {highlightText && <p style={{ fontWeight: 800, fontSize: '0.9rem', marginBottom: 14, background: 'rgba(255,255,255,0.12)', borderRadius: 8, padding: '8px 12px', display: 'inline-block' }}>{highlightText}</p>}
          <p style={{ opacity: 0.9, marginBottom: 16, fontSize: '0.85rem' }}>{companyName} would like to extend our deepest gratitude for your clinical excellence and the compassionate care you provide to those living with epilepsy.</p>
          <p style={{ opacity: 0.85, marginBottom: 16, fontSize: '0.85rem' }}>Your work makes the journey easier and the future brighter for countless families.</p>
          <p style={{ fontWeight: 800, fontSize: '0.9rem' }}>{footerText}</p>
        </div>
      </div>
      <div style={{ marginTop: 24, background: 'rgba(255,255,255,0.95)', padding: '16px 28px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ flex: 1 }}><Butterfly size={70} /></div>
        <div style={{ flex: 2, textAlign: 'center' }}>
          {template?.productLogo ? <img src={`${API}${template.productLogo}`} alt="product" style={{ maxHeight: 36, maxWidth: 140, objectFit: 'contain' }} crossOrigin="anonymous" />
            : <div><div style={{ fontSize: '1.1rem', fontWeight: 800, color: '#4C1D95' }}>{productName.split('(')[0]}</div>{productName.includes('(') && <div style={{ fontSize: '0.7rem', color: '#6D28D9' }}>({productName.split('(')[1].replace(')', '')})</div>}</div>}
        </div>
        <div style={{ flex: 1, textAlign: 'right' }}>
          {template?.companyLogo ? <img src={`${API}${template.companyLogo}`} alt="company" style={{ maxHeight: 40, maxWidth: 80, objectFit: 'contain' }} crossOrigin="anonymous" />
            : <div><div style={{ fontSize: '0.85rem', fontWeight: 800, color: '#1F2937' }}>{companyName}</div></div>}
        </div>
      </div>
    </div>
  );
}

// // Image-mode poster — doctor photo & name overlaid on custom background image or video
function ImagePoster({ doctor, template, posterRef }) {
  const bgSrc = template?.backgroundImage ? `${API}${template.backgroundImage}` : null;
  const POSTER_W = 440;
  const POSTER_H = Math.round(POSTER_W * 1.5); // 3:2 portrait ratio
  const photoSizePx = Math.round(((template?.photoSize || 22) / 100) * POSTER_W);
  const photoLeft = Math.round(((template?.photoX || 50) / 100) * POSTER_W) - photoSizePx / 2;
  const photoTop = Math.round(((template?.photoY || 18) / 100) * POSTER_H) - photoSizePx / 2;
  const nameLeft = Math.round(((template?.nameX || 50) / 100) * POSTER_W);
  const nameTop = Math.round(((template?.nameY || 38) / 100) * POSTER_H);

  // Check if background is a video
  const isVideo = bgSrc && (bgSrc.includes('.mp4') || bgSrc.includes('.mov') || bgSrc.includes('.avi') || bgSrc.includes('.webm'));

  return (
    <div ref={posterRef} style={{ width: POSTER_W, maxWidth: '100%', height: POSTER_H, position: 'relative', borderRadius: 20, overflow: 'hidden', boxShadow: '0 32px 80px rgba(0,0,0,0.35)', userSelect: 'none', background: '#1a1a2e' }}>
      {bgSrc && (
        isVideo ? (
          <video 
            src={bgSrc} 
            autoPlay 
            loop 
            muted 
            playsInline
            controls
            crossOrigin="anonymous"
            style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', position: 'absolute', top: 0, left: 0 }}
          />
        ) : (
          <img src={bgSrc} alt="poster" crossOrigin="anonymous" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', position: 'absolute', top: 0, left: 0 }} />
        )
      )}
      {/* Doctor photo */}
      <div style={{ position: 'absolute', left: photoLeft, top: photoTop, width: photoSizePx, height: photoSizePx, borderRadius: '50%', border: '4px solid rgba(255,255,255,0.8)', overflow: 'hidden', background: 'rgba(255,255,255,0.2)', boxShadow: '0 8px 32px rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        {doctor.picture ? <img src={`${API}${doctor.picture}`} alt={doctor.name} crossOrigin="anonymous" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : <span style={{ fontSize: photoSizePx * 0.4 }}>👨‍⚕️</span>}
      </div>
      {/* Doctor name */}
      <div style={{ position: 'absolute', left: nameLeft, top: nameTop, transform: 'translateX(-50%)', color: template?.nameColor || '#ffffff', fontSize: template?.nameFontSize || 28, fontWeight: 800, textShadow: '0 3px 12px rgba(0,0,0,0.7)', textAlign: 'center', whiteSpace: 'nowrap', fontFamily: 'DM Sans, sans-serif', letterSpacing: '-0.5px' }}>
        {doctor.name}
      </div>
    </div>
  );
}

// function ImagePoster({ doctor, template, posterRef }) {
//   const [showOverlay, setShowOverlay] = useState(false);

//   const bgSrc = template?.backgroundImage ? `${API}${template.backgroundImage}` : null;
//   const POSTER_W = 440;
//   const POSTER_H = Math.round(POSTER_W * 1.5);
//   const photoSizePx = Math.round(((template?.photoSize || 22) / 100) * POSTER_W);
//   const photoLeft = Math.round(((template?.photoX || 50) / 100) * POSTER_W) - photoSizePx / 2;
//   const photoTop = Math.round(((template?.photoY || 18) / 100) * POSTER_H) - photoSizePx / 2;
//   const nameLeft = Math.round(((template?.nameX || 50) / 100) * POSTER_W);
//   const nameTop = Math.round(((template?.nameY || 38) / 100) * POSTER_H);
//   const isVideo = bgSrc && /\.(mp4|mov|avi|webm)$/i.test(bgSrc);
//   const videoRef = useRef(null);

//   useEffect(() => {
//     const v = videoRef.current;
//     if (!v) return;

//     v.muted = true;
//     v.play().catch(() => { });

//     if (isVideo) setShowOverlay(true);
//   }, [bgSrc]);

//   return (
//     <>
//       {bgSrc && isVideo && showOverlay && (
//         <div
//           onClick={() => {
//             const v = videoRef.current;
//             if (v) v.muted = false;
//             setShowOverlay(false);
//           }}
//           style={{
//             position: 'absolute',
//             top: 0, left: 0,
//             width: '100%', height: '100%',
//             zIndex: 5,
//             cursor: 'pointer',
//           }}
//         />
//       )}
//       <div
//         ref={posterRef}
//         style={{
//           width: POSTER_W,
//           maxWidth: '100%',
//           height: POSTER_H,
//           position: 'relative',
//           borderRadius: 20,
//           overflow: 'hidden',
//           boxShadow: '0 32px 80px rgba(0,0,0,0.35)',
//           userSelect: 'none',
//           background: '#1a1a2e',
//         }}
//       >
//         {bgSrc && (
//           isVideo ? (
//             <video
//               ref={videoRef}
//               src={bgSrc}
//               loop
//               muted
//               playsInline
//               crossOrigin="anonymous"
//               style={{
//                 width: '100%',
//                 height: '100%',
//                 objectFit: 'cover',
//                 display: 'block',
//                 position: 'absolute',
//                 top: 0,
//                 left: 0,
//               }}
//             />
//           ) : (
//             <img
//               src={bgSrc}
//               alt="poster"
//               crossOrigin="anonymous"
//               style={{
//                 width: '100%',
//                 height: '100%',
//                 objectFit: 'cover',
//                 display: 'block',
//                 position: 'absolute',
//                 top: 0,
//                 left: 0,
//               }}
//             />
//           )
//         )}

//         {/* Doctor photo */}
//         <div
//           style={{
//             position: 'absolute',
//             left: photoLeft,
//             top: photoTop,
//             width: photoSizePx,
//             height: photoSizePx,
//             borderRadius: '50%',
//             border: '4px solid rgba(255,255,255,0.8)',
//             overflow: 'hidden',
//             background: 'rgba(255,255,255,0.2)',
//             boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//           }}
//         >
//           {doctor.picture ? (
//             <img
//               src={`${API}${doctor.picture}`}
//               alt={doctor.name}
//               crossOrigin="anonymous"
//               style={{ width: '100%', height: '100%', objectFit: 'cover' }}
//             />
//           ) : (
//             <span style={{ fontSize: photoSizePx * 0.4 }}>👨‍⚕️</span>
//           )}
//         </div>

//         {/* Doctor name */}
//         <div
//           style={{
//             position: 'absolute',
//             left: nameLeft,
//             top: nameTop,
//             transform: 'translateX(-50%)',
//             color: template?.nameColor || '#ffffff',
//             fontSize: template?.nameFontSize || 28,
//             fontWeight: 800,
//             textShadow: '0 3px 12px rgba(0,0,0,0.7)',
//             textAlign: 'center',
//             whiteSpace: 'nowrap',
//             fontFamily: 'DM Sans, sans-serif',
//             letterSpacing: '-0.5px',
//           }}
//         >
//           {doctor.name}
//         </div>
//       </div>
//     </>

//   );
// }

export default function PublicProfile() {
  const { slug } = useParams();
  const [doctor, setDoctor] = useState(null);
  const [template, setTemplate] = useState(null);
  const [campaign, setCampaign] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const posterRef = useRef();

  useEffect(() => {
    const load = async () => {
      try {
        const { data: doc } = await axios.get(`/api/doctors/profile/${slug}`);
        setDoctor(doc);

        let foundCampaign = null;
        try {
          // Use dedicated endpoint — applies full date logic on backend
          // (isActive=true AND startDate<=now AND endDate>=now)
          const { data } = await axios.get(`/api/campaigns/active-for-doctor/${doc._id}`);
          if (data.campaign) {
            foundCampaign = data.campaign;
            setCampaign(data.campaign);
            if (data.template) {
              setTemplate(data.template);
            }
          }
        } catch (e) { /* no campaign is fine */ }

        // Record scan + try to get geolocation from browser
        const scanPayload = { doctorId: doc._id };
        if (foundCampaign?._id) scanPayload.campaignId = foundCampaign._id;

        // Ask browser for location (non-blocking)
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (pos) => {
              scanPayload.latitude = pos.coords.latitude;
              scanPayload.longitude = pos.coords.longitude;
              axios.post('/api/scan/record', scanPayload).catch(() => { });
            },
            () => {
              // User denied or unavailable — record without location
              axios.post('/api/scan/record', scanPayload).catch(() => { });
            },
            { timeout: 5000 }
          );
        } else {
          axios.post('/api/scan/record', scanPayload).catch(() => { });
        }
      } catch (err) {
        setError('Doctor profile not found');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [slug]);

  const downloadPoster = async (format = 'png') => {
    if (!posterRef.current) return;
    try {
      const canvas = await html2canvas(posterRef.current, { scale: 2, useCORS: true, allowTaint: true, backgroundColor: null });
      const link = document.createElement('a');
      link.download = `Dr_${doctor.name.replace(/\s+/g, '_')}_Poster.${format}`;
      link.href = canvas.toDataURL(format === 'jpg' ? 'image/jpeg' : 'image/png', 0.95);
      link.click();
    } catch (e) { alert('Download failed. Please try again.'); }
  };

  const bg1 = template?.backgroundColor || '#5B21B6';
  const bg2 = template?.gradientColor || '#7C3AED';
  const isImageMode = template?.mode === 'image';

  if (loading) return (
    <div style={{ minHeight: '100vh', background: `linear-gradient(135deg, ${bg1}, ${bg2})`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ textAlign: 'center', color: 'white' }}><Butterfly size={80} /><div style={{ marginTop: 16, fontSize: '1.1rem', opacity: 0.8 }}>Loading...</div></div>
    </div>
  );

  if (error) return (
    <div style={{ minHeight: '100vh', background: `linear-gradient(135deg, ${bg1}, ${bg2})`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ textAlign: 'center', color: 'white', padding: 40 }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>🔍</div>
        <h2>Profile Not Found</h2>
        <p style={{ opacity: 0.7, marginTop: 8 }}>This QR code may have expired or the profile doesn't exist.</p>
      </div>
    </div>
  );

  return (
    <div style={{ minHeight: '100vh', background: `linear-gradient(135deg, ${bg1}22 0%, ${bg2}33 100%)`, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '24px 16px', fontFamily: 'DM Sans, sans-serif' }}>
      {isImageMode
        ? <ImagePoster doctor={doctor} template={template} posterRef={posterRef} />
        : <FormPoster doctor={doctor} template={template} posterRef={posterRef} />
      }

      <div style={{ marginTop: 24, display: 'flex', gap: 12 }}>
        <button onClick={() => downloadPoster('png')} style={{ padding: '11px 22px', borderRadius: 10, background: `linear-gradient(135deg, ${bg1}, ${bg2})`, color: 'white', border: 'none', cursor: 'pointer', fontWeight: 600, fontSize: '0.875rem', boxShadow: `0 4px 16px ${bg1}66`, fontFamily: 'DM Sans, sans-serif' }}>
          ⬇ Download PNG
        </button>
        <button onClick={() => downloadPoster('jpg')} style={{ padding: '11px 22px', borderRadius: 10, background: 'white', color: bg1, border: `2px solid ${bg1}`, cursor: 'pointer', fontWeight: 600, fontSize: '0.875rem', fontFamily: 'DM Sans, sans-serif' }}>
          ⬇ Download JPG
        </button>
      </div>
      <div style={{ marginTop: 14, fontSize: '0.75rem', color: '#9CA3AF', textAlign: 'center' }}>
        {template?.companyName || 'Hilton Pharma'} · Campaign QR System
        {campaign && <span> · {campaign.name}</span>}
      </div>
    </div>
  );
}
